var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": "1rem", "padding-bottom": "1.2rem" } },
    [
      _c("topbar", { attrs: { text: "精品文章", status: true } }),
      _vm._v(" "),
      _c("div", { staticClass: "mainBox" }, [
        _c("div", { staticClass: "articleTitle" }, [
          _vm._v(_vm._s(_vm.articleDetail.title))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "authorBox" }, [
          _vm._v("作者：" + _vm._s(_vm.articleDetail.author) + " "),
          _c("span", [
            _vm._v(_vm._s(_vm._f("time")(_vm.articleDetail.createTime)))
          ])
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "contentBox",
          domProps: { innerHTML: _vm._s(_vm.articleDetail.content) }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "commentBox" }, [
        _c("div", { staticClass: "modeTitle" }, [
          _vm._v(
            "\n                全部评论(" +
              _vm._s(_vm.count) +
              "):\n                "
          ),
          _c("div")
        ]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.articleCommentList, function(item) {
            return _c("li", [
              _c("div", { staticClass: "userBox" }, [
                _c("div", { staticClass: "userImg" }),
                _vm._v(" "),
                _c("div", { staticClass: "userTopRightBox" }, [
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(item.nickName))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "time" }, [
                    _vm._v(_vm._s(_vm._f("time")(item.createTime)))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "userContent" }, [
                _vm._v(_vm._s(item.content))
              ])
            ])
          })
        )
      ]),
      _vm._v(" "),
      _vm.mask
        ? _c("div", { staticClass: "maskBox" }, [
            _c("div", { staticClass: "inputBox" }, [
              _c("div", { staticClass: "inputTop" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.cancle()
                      }
                    }
                  },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c("span", { on: { click: _vm.commitArticleComment } }, [
                  _vm._v("提交")
                ])
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.content,
                    expression: "content"
                  }
                ],
                attrs: {
                  autofocus: "",
                  id: "textarea",
                  placeholder: "写下你的看法吧！"
                },
                domProps: { value: _vm.content },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.content = $event.target.value
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "fixedBox" }, [
        _c(
          "div",
          {
            staticClass: "input",
            on: {
              click: function($event) {
                _vm.openMask()
              }
            }
          },
          [
            _c("div", { staticClass: "inputIcon" }),
            _vm._v("\n                发表评论\n            ")
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "fabulous",
            class: { active: _vm.likeStatus },
            on: {
              click: function($event) {
                _vm.doLoveArticle()
              }
            }
          },
          [
            _c("div", { staticClass: "c-num" }, [
              _vm._v(_vm._s(_vm.articleDetail.loveCount))
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "toTeacher",
            on: {
              click: function($event) {
                _vm.to("ask")
              }
            }
          },
          [_vm._v("咨询老师")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f1be8cf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1be8cf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/articleDetail.vue
// module id = null
// module chunks = 